import { all, call, getContext, put, takeEvery, takeLatest } from 'redux-saga/effects';

import type { Session } from '../domain/session.model';
import type { SecuritySessionsGateway } from '../infrastructure/security-sessions.gateway';
import { loadRequested, revokeRequested } from './security-sessions.actions';
import { securitySessionsActions } from './security-sessions.slice';

/** WORKER: load the current user's sessions. On failure the list resets empty. */
function* loadWorker() {
  const gateway: SecuritySessionsGateway = yield getContext('securitySessionsGateway');
  yield put(securitySessionsActions.loadStarted());
  try {
    const sessions = (yield call(gateway.listSessions)) as Session[];
    yield put(securitySessionsActions.loadSucceeded(sessions));
  } catch {
    yield put(securitySessionsActions.loadFailed());
  }
}

/**
 * WORKER: revoke one session. `takeEvery` so several rows can be revoked
 * concurrently; the row spinner is driven by `revokingId`. A failure silently
 * clears the spinner (mirrors the old page, which ignored revoke errors).
 */
function* revokeWorker(action: ReturnType<typeof revokeRequested>) {
  const gateway: SecuritySessionsGateway = yield getContext('securitySessionsGateway');
  yield put(securitySessionsActions.revokeStarted(action.payload));
  try {
    yield call(gateway.revokeSession, action.payload);
    yield put(securitySessionsActions.revokeSucceeded(action.payload));
  } catch {
    yield put(securitySessionsActions.revokeFailed());
  }
}

/** WATCHERS. */
export function* securitySessionsSaga() {
  yield all([
    takeLatest(loadRequested.type, loadWorker),
    takeEvery(revokeRequested.type, revokeWorker),
  ]);
}
